import React from "react";
import { Alert, AlertTitle, Button, Stack } from "@mui/material";

interface TokenWarningProps {
  availableTokens: number;
  requiredTokens: number;
  onBuyTokens?: () => void;
}

const TokenWarning: React.FC<TokenWarningProps> = ({
  availableTokens,
  requiredTokens,
  onBuyTokens,
}) => {
  const notEnough = availableTokens < requiredTokens;

  if (!notEnough) return null;

  return (
    <Stack sx={{ width: "55%" }} spacing={2}>
      <Alert
        severity="warning"
        action={
          onBuyTokens && (
            <Button color="inherit" size="small" onClick={onBuyTokens}>
              Buy Tokens
            </Button>
          )
        }
      >
        <AlertTitle>Not Enough Tokens</AlertTitle>
        You only have <strong>{availableTokens?.toFixed(2)}</strong> tokens, but posting a
        job requires <strong>{requiredTokens?.toFixed(2)}</strong>. Please purchase more
        tokens to continue.
      </Alert>
    </Stack>
  );
};

export default TokenWarning;
